(() => {
  const configNode = document.getElementById('ss-products-mobile-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const locale = config.locale.startsWith('th') ? 'th' : config.locale.startsWith('zh') ? 'zh' : 'en';
  const copy = {
    th: {story:'เรื่องราวของวัตถุดิบธรรมชาติ', categories:['เส้นผม','ผิวกาย','เซ็ตออนไลน์'], viewAll:'ดูทั้งหมด'},
    en: {story:'Our natural ingredients', categories:['Hair','Body','Online Sets'], viewAll:'View all'},
    zh: {story:'天然成分的故事', categories:['护发','身体','线上套装'], viewAll:'查看全部'}
  }[locale];
  const sections = id => document.querySelector('.shopify-section[id$="__' + id + '"]');
  const media = matchMedia('(max-width:749px)');
  let cleanup = null;
  function enable() {
    if (cleanup) return;
    const undo = [], added = [], controller = new AbortController();
    let frame = 0;
    document.documentElement.classList.add('ss-products-mobile');
    const rememberHTML = (element, html) => {
      if (!element) return;
      const original = element.innerHTML;
      undo.push(() => { element.innerHTML = original; });
      element.innerHTML = html;
    };
    const move = (element, destination) => {
      if (!element) return;
      const placeholder = document.createComment('products-mobile-original-position');
      element.before(placeholder);
      destination.append(element);
      undo.push(() => { placeholder.replaceWith(element); });
    };
    const hero = sections('natural_extracts_hero');
    const heroContainer = hero?.querySelector('.nehero');
    if (heroContainer) {
      rememberHTML(hero.querySelector('.ne-h'), 'NATURAL EXTRACTS');
      rememberHTML(hero.querySelector('.ne-tag'), '<span>INSPIRED BY HERBS</span><span class="ss-balance">DRIVEN BY BALANCE</span>');
      const details = document.createElement('details');
      details.className = 'ss-products-story';
      const summary = document.createElement('summary');
      summary.textContent = copy.story;
      summary.insertAdjacentHTML('beforeend', config.chevron);
      details.append(summary);
      heroContainer.append(details);
      added.push(details);
      move(hero.querySelector('.ne-body'), details);
      move(sections('cta_banner_3WPCHm'), details);
    }
    const categories = sections('multicolumn_ATfzVG');
    const imageLinks = categories?.querySelectorAll('.multicolumn-card__imglink') || [];
    imageLinks.forEach((link, index) => {
      const label = document.createElement('span');
      label.className = 'ss-products-category-label';
      label.textContent = copy.categories[index];
      link.append(label);
      added.push(label);
    });
    config.collections.forEach(item => {
      const section = sections(item.id);
      const title = section?.querySelector('.collection__title');
      if (!title) return;
      const originalLink = section.querySelector('.collection__view-all a');
      const link = document.createElement('a');
      link.className = 'ss-products-view-all';
      link.href = originalLink?.href || config.root + 'collections/' + item.handle;
      link.textContent = copy.viewAll;
      link.insertAdjacentHTML('beforeend', config.arrow);
      title.append(link);
      added.push(link);
    });
    function updateHeaderOffset() {
      frame = 0;
      const header = document.querySelector('.shopify-section-header');
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const offset = Math.min(140, headerBottom);
      document.documentElement.style.setProperty('--ss-products-header-height', offset + 'px');

    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(updateHeaderOffset); };
    window.addEventListener('scroll', schedule, {passive:true, signal:controller.signal});
    window.addEventListener('resize', schedule, {passive:true, signal:controller.signal});
    updateHeaderOffset();
    cleanup = () => {
      controller.abort();
      cancelAnimationFrame(frame);
      undo.reverse().forEach(restore => restore());
      added.forEach(element => element.remove());
      document.documentElement.classList.remove('ss-products-mobile');
      document.documentElement.style.removeProperty('--ss-products-header-height');
      cleanup = null;
    };
  }
  const sync = () => { if (media.matches) enable(); else cleanup?.(); };
  media.addEventListener('change', sync);
  sync();
})();
